/* eslint-disable */
import { OptionType } from '../enums/OptionTypeProto';
import { OptionHedgeType } from '../enums/OptionHedgeTypeProto';
import { OptionCut } from '../enums/OptionCutProto';
import { OptionPremiumDelivery } from '../enums/OptionPremiumDeliveryProto';
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'com.celertech.orderrouting.api.order';

export interface OptionRequestFields {
    type: OptionType;
    premiumCurrency: string;
    strikePrice: number;
    expiry: string;
    hedgeType: OptionHedgeType;
    hedgeFields?: OptionHedgeFields;
    cut: OptionCut;
    premiumDeliveryType: OptionPremiumDelivery;
}

export interface OptionResponseFields {
    bidPremium: number;
    bidVol: number;
    offerPremium: number;
    offerVol: number;
}

export interface OptionHedgeFields {
    rate: number;
    qty: number;
    currency: string;
}

function createBaseOptionRequestFields(): OptionRequestFields {
    return {
        type: 1,
        premiumCurrency: '',
        strikePrice: 0,
        expiry: '',
        hedgeType: 1,
        hedgeFields: undefined,
        cut: 1,
        premiumDeliveryType: 1
    };
}

export const OptionRequestFields = {
    encode(message: OptionRequestFields, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.type !== 1) {
            writer.uint32(8).int32(message.type);
        }
        if (message.premiumCurrency !== '') {
            writer.uint32(18).string(message.premiumCurrency);
        }
        if (message.strikePrice !== 0) {
            writer.uint32(25).double(message.strikePrice);
        }
        if (message.expiry !== '') {
            writer.uint32(34).string(message.expiry);
        }
        if (message.hedgeType !== 1) {
            writer.uint32(40).int32(message.hedgeType);
        }
        if (message.hedgeFields !== undefined) {
            OptionHedgeFields.encode(message.hedgeFields, writer.uint32(50).fork()).ldelim();
        }
        if (message.cut !== 1) {
            writer.uint32(56).int32(message.cut);
        }
        if (message.premiumDeliveryType !== 1) {
            writer.uint32(64).int32(message.premiumDeliveryType);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): OptionRequestFields {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOptionRequestFields();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.type = reader.int32() as any;
                    break;
                case 2:
                    message.premiumCurrency = reader.string();
                    break;
                case 3:
                    message.strikePrice = reader.double();
                    break;
                case 4:
                    message.expiry = reader.string();
                    break;
                case 5:
                    message.hedgeType = reader.int32() as any;
                    break;
                case 6:
                    message.hedgeFields = OptionHedgeFields.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.cut = reader.int32() as any;
                    break;
                case 8:
                    message.premiumDeliveryType = reader.int32() as any;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<OptionRequestFields>): OptionRequestFields {
        const message = createBaseOptionRequestFields();
        message.type = object.type ?? 1;
        message.premiumCurrency = object.premiumCurrency ?? '';
        message.strikePrice = object.strikePrice ?? 0;
        message.expiry = object.expiry ?? '';
        message.hedgeType = object.hedgeType ?? 1;
        message.hedgeFields =
            object.hedgeFields !== undefined && object.hedgeFields !== null
                ? OptionHedgeFields.fromPartial(object.hedgeFields)
                : undefined;
        message.cut = object.cut ?? 1;
        message.premiumDeliveryType = object.premiumDeliveryType ?? 1;
        return message;
    }
};

function createBaseOptionResponseFields(): OptionResponseFields {
    return { bidPremium: 0, bidVol: 0, offerPremium: 0, offerVol: 0 };
}

export const OptionResponseFields = {
    encode(message: OptionResponseFields, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.bidPremium !== 0) {
            writer.uint32(9).double(message.bidPremium);
        }
        if (message.bidVol !== 0) {
            writer.uint32(17).double(message.bidVol);
        }
        if (message.offerPremium !== 0) {
            writer.uint32(25).double(message.offerPremium);
        }
        if (message.offerVol !== 0) {
            writer.uint32(33).double(message.offerVol);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): OptionResponseFields {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOptionResponseFields();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bidPremium = reader.double();
                    break;
                case 2:
                    message.bidVol = reader.double();
                    break;
                case 3:
                    message.offerPremium = reader.double();
                    break;
                case 4:
                    message.offerVol = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<OptionResponseFields>): OptionResponseFields {
        const message = createBaseOptionResponseFields();
        message.bidPremium = object.bidPremium ?? 0;
        message.bidVol = object.bidVol ?? 0;
        message.offerPremium = object.offerPremium ?? 0;
        message.offerVol = object.offerVol ?? 0;
        return message;
    }
};

function createBaseOptionHedgeFields(): OptionHedgeFields {
    return { rate: 0, qty: 0, currency: '' };
}

export const OptionHedgeFields = {
    encode(message: OptionHedgeFields, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.rate !== 0) {
            writer.uint32(9).double(message.rate);
        }
        if (message.qty !== 0) {
            writer.uint32(16).int32(message.qty);
        }
        if (message.currency !== '') {
            writer.uint32(26).string(message.currency);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): OptionHedgeFields {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOptionHedgeFields();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rate = reader.double();
                    break;
                case 2:
                    message.qty = reader.int32();
                    break;
                case 3:
                    message.currency = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<OptionHedgeFields>): OptionHedgeFields {
        const message = createBaseOptionHedgeFields();
        message.rate = object.rate ?? 0;
        message.qty = object.qty ?? 0;
        message.currency = object.currency ?? '';
        return message;
    }
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
    ? T
    : T extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepPartial<U>>
    : T extends {}
    ? { [K in keyof T]?: DeepPartial<T[K]> }
    : Partial<T>;
